/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Internal/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Name from './Name/index'
import OpenPatientAction from './OpenPatientAction/index'
import React from 'react'
import TysiaIconChat from 'DesignSystem/Svgs/TysiaIconChat/index'



/** @type {import('Simple/types.js').View} */
export default function Internal({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/Internal"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaIconChat
  viewPath={`${viewPath}/TysiaIconChat`}
 marginRight={6}
 width={dtSpaceS}
 height={dtSpaceS}
 stroke="rgba(0,0,0,0.7)"
/>
<Name
  viewPath={`${viewPath}/Name`}
/>
<OpenPatientAction
  viewPath={`${viewPath}/OpenPatientAction`}
/>
{children}
</React.Fragment>)
}